import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead } from "../../components/ui-bits";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

const CAT_COLORS = {
  GST: "#002FA7", ITR: "#00A86B", TDS: "#F5A623", ROC: "#0891B2", Audit: "#DC2626",
  Payroll: "#DB2777", CMA: "#7C3AED", Bookkeeping: "#0F766E", Accounting: "#111111", Advisory: "#4B5563", Other: "#9CA3AF",
};
const tip = { contentStyle: { background: "#111", border: "none", borderRadius: 2, color: "#fff", fontSize: 12 } };

export default function AdminReports() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/category-report").then((r) => setRows(r.data)); }, []);

  const totals = rows.reduce((a, r) => ({ total: a.total + r.total, completed: a.completed + r.completed, active: a.active + r.active }), { total: 0, completed: 0, active: 0 });

  return (
    <div>
      <PageHead eyebrow="Jobs & Turnaround by Service" title="Category Reports" />

      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="card p-5"><p className="label mb-1">Total Jobs</p><p className="font-head font-black text-3xl tnum">{totals.total}</p></div>
        <div className="card p-5"><p className="label mb-1">Completed</p><p className="font-head font-black text-3xl tnum text-[#00A86B]">{totals.completed}</p></div>
        <div className="card p-5"><p className="label mb-1">In Progress</p><p className="font-head font-black text-3xl tnum text-[#F5A623]">{totals.active}</p></div>
      </div>

      <div className="card p-6 mb-6">
        <p className="label mb-4">Jobs per Service</p>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={rows}>
            <CartesianGrid strokeDasharray="2 2" vertical={false} stroke="#eee" />
            <XAxis dataKey="category" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
            <Tooltip {...tip} />
            <Bar dataKey="total" radius={[3, 3, 0, 0]}>
              {rows.map((r, i) => <Cell key={i} fill={CAT_COLORS[r.category] || "#9CA3AF"} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="card overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead><tr className="label text-left border-b border-black/10">
            <th className="px-5 py-3">Service</th><th className="py-3 text-right">Total</th><th className="py-3 text-right">Completed</th>
            <th className="py-3 text-right">Active</th><th className="py-3 text-right">Avg Progress</th><th className="py-3 text-right">Avg Turnaround</th><th className="py-3 text-right pr-5">SLA (target)</th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.category} data-testid={`cat-row-${i}`} className={`border-b border-black/5 ${r.sla_breach ? "bg-[#FF3B30]/[0.04]" : ""}`}>
                <td className="px-5 py-3 font-medium flex items-center gap-2">
                  <span className="w-2.5 h-2.5 rounded-full" style={{ background: CAT_COLORS[r.category] || "#9CA3AF" }} /> {r.category}
                </td>
                <td className="py-3 text-right tnum">{r.total}</td>
                <td className="py-3 text-right tnum text-[#00A86B]">{r.completed}</td>
                <td className="py-3 text-right tnum text-[#F5A623]">{r.active}</td>
                <td className="py-3 text-right tnum">{r.avg_progress}%</td>
                <td className={`py-3 text-right tnum ${r.sla_breach ? "text-[#FF3B30] font-semibold" : ""}`}>
                  {r.avg_turnaround_days != null ? `${r.avg_turnaround_days} d` : "—"}
                  {r.sla_breach && <span data-testid={`sla-breach-${i}`} className="ml-2 text-[10px] uppercase font-bold bg-[#FF3B30] text-white px-1.5 py-0.5 rounded-sm">SLA breach</span>}
                </td>
                <td className="py-3 text-right pr-5 tnum text-[#888]">{r.sla_target_days} d</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-5 py-8 text-center text-[#888]">No job data yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
